import React from 'react';
import { Row, Col, Button, Alert } from 'reactstrap';

import { useAdminUser } from '../../contexts';
import { logoutAdmin } from '../../utils';
import DataTable from '../DataTable';

const SkeletonRow = () => (
  <tr>
    <td style={{ width: '40%' }}>
      <div
        style={{
          height: '14px',
          width: '60%',
          background: '#e9ecef',
          borderRadius: '4px',
        }}
      />
    </td>
    <td>
      <div
        style={{
          height: '14px',
          width: '80%',
          background: '#e9ecef',
          borderRadius: '4px',
        }}
      />
    </td>
  </tr>
);

const AccountProfile = () => {
  const { administrator, isLoading, clear } = useAdminUser();

  if (isLoading) {
    return (
      <Row>
        <Col xs={12} md={8}>
          <DataTable card={false}>
            <tbody>
              {[1, 2, 3, 4, 5].map((n) => (
                <SkeletonRow key={n} />
              ))}
            </tbody>
          </DataTable>
        </Col>
      </Row>
    );
  }

  if (!administrator) {
    return (
      <Alert color="danger">
        Unable to load profile. Please refresh the page.
      </Alert>
    );
  }

  const rows = [
    { label: 'Name', value: administrator.user.name },
    { label: 'Email', value: administrator.user.email },
    { label: 'Phone', value: administrator.user.phone },
    { label: 'Role', value: administrator.roles },
    { label: 'User ID', value: administrator.user_id },
  ];

  return (
    <Row>
      <Col xs={12} md={8}>
        <DataTable card={false}>
          <tbody>
            {rows.map((row) => (
              <tr key={row.label}>
                <td className="text-muted" style={{ width: '40%' }}>
                  {row.label}
                </td>
                <td>{row.value || '—'}</td>
              </tr>
            ))}
          </tbody>
        </DataTable>

        <Button
          color="danger"
          onClick={() => {
            clear();
            logoutAdmin();
          }}
        >
          Logout
        </Button>
      </Col>
    </Row>
  );
};

export default AccountProfile;
